import { EmployeeWorkSheetDetails } from "@/model/employee-work-details/employee-worksheet-details";
import { Component, OnInit } from "@angular/core";
import { AppService } from "@services/app.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subject, takeUntil } from "rxjs";
import { AggregatedEmployeeData } from "@/model/employee-work-details/aggregated-employee-data";

@Component({
  selector: "app-worksheet-entry-table",
  templateUrl: "./worksheet-entry-table.component.html",
  styleUrl: "./worksheet-entry-table.component.scss",
})
export class WorksheetEntryTableComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  wagsMonth: string = "";
  getAllWagsMonth: string[] = [];
  worksheetEntryDetails: EmployeeWorkSheetDetails[] = [];
  aggregatedData: AggregatedEmployeeData[] = [];
  allAggregatedData: AggregatedEmployeeData[] = [];
  employeeNames: string[] = [];
  selectedEmployee: AggregatedEmployeeData | null = null;
  selectedEmployeeName: string = "";
  isShowPopup: boolean = false;
  totalCompletedImageCount: number = 0;
  TotalIndexCount: string = "";
  anyAddedImageCount: string = "";
  noExtractableDataCount: string = "";
  accountableIndexingCount: string = "";
  accountIndexingCost: string = "";
  assignCount: string = "";

  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    this.getWagsMonthList();
  }

  /* Get wags month List */
  getWagsMonthList() {
    this.spinner.show();
    this.appService
      .getListOfWagsMonth()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          // Filter out empty strings
          this.getAllWagsMonth = data.filter((item) => item != "");

          this.getAllWagsMonth.sort((a, b) => {
            const dateA = new Date("01-" + a);
            const dateB = new Date("01-" + b);
            return dateB.getTime() - dateA.getTime();
          });

          // Set the first (latest) month
          this.wagsMonth = this.getAllWagsMonth[0];
          this.wagsMonthBasedDetailsGet(this.wagsMonth);
        },
        (error: any) => {
          // Handle error (optional)
          this.spinner.hide();
        }
      );
  }

  /* get wags month based worksheet details  */
  wagsMonthBasedDetailsGet(month: string) {
    this.spinner.show();
    this.appService
      .wagsMonthBasedDetailsGet(month)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.worksheetEntryDetails = data;
          this.processData();
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }

  processData() {
    const map = new Map<string, AggregatedEmployeeData>();

    this.worksheetEntryDetails.forEach((entry) => {
      if (!map.has(entry.employeeName)) {
        map.set(entry.employeeName, {
          employeeName: entry.employeeName,
          totalImageCount: 0,
          noOfImagesCompleted: 0,
          availableCount: 0,
          noOfLinesTyped: 0,
          accountableIndexing: 0,
          accountIndexingCost: 0,
          noExtractableData: 0,
          anyAddedImageCount: 0,
          assignCount: 0,
          entries: [],
        });
      }

      const group = map.get(entry?.employeeName)!;
      group.totalImageCount += entry?.totalImageCount || 0;
      group.noOfImagesCompleted += entry?.noOfImagesCompleted || 0;
      group.availableCount += entry?.availableCount || 0;
      group.noOfLinesTyped += entry?.noOfLinesTyped || 0;
      group.noExtractableData += entry?.noExtractableData || 0;
      group.accountableIndexing += entry?.accountableIndexing || 0;
      group.accountIndexingCost += entry?.accountIndexingCost || 0;
      group.assignCount += entry?.assignCount || 0;
      group.anyAddedImageCount += entry?.anyAddedImageCount || 0;
      group.entries.push(entry);
    });

    // Set both original and displayed data
    this.allAggregatedData = Array.from(map.values());
    this.aggregatedData = [...this.allAggregatedData];

    // Extract unique employee names for dropdown
    this.employeeNames = this.allAggregatedData.map((d) => d.employeeName);
  }

  openModal(employee: AggregatedEmployeeData) {
    this.selectedEmployee = employee;
    this.totalCompletedImageCount += this.selectedEmployee.noOfImagesCompleted;
    this.TotalIndexCount = this.selectedEmployee?.noOfLinesTyped.toString();
    this.assignCount = this.selectedEmployee?.assignCount.toString();
    this.noExtractableDataCount =
      this.selectedEmployee?.noExtractableData.toString();
    this.anyAddedImageCount =
      this.selectedEmployee?.accountableIndexing.toString();
    this.accountableIndexingCount =
      this.selectedEmployee?.accountIndexingCost.toString();
    this.accountIndexingCost =
      this.selectedEmployee?.accountIndexingCost.toString();
    this.isShowPopup = true;
  }

  closeModal() {
    this.selectedEmployee = null;
    this.isShowPopup = false;
  }

  filterByEmployee() {
    if (this.selectedEmployeeName) {
      this.aggregatedData = this.allAggregatedData.filter(
        (d) => d.employeeName === this.selectedEmployeeName
      );
    } else {
      this.aggregatedData = [...this.allAggregatedData];
    }
  }
}
